var map = {
	"./everyone_asking_disease.png": "QgM+",
	"./everyone_asking_new_technology.png": "3Vi4",
	"./everyone_asking_operation.png": "j5/J"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Kg4T";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/everyone_asking_.*\.png$
// module id = Kg4T
// module chunks = 1